import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_dashboard/$datasetSlug/custom-ui/$id")({
  beforeLoad: ({ params }) => { throw redirect({ to: "/$datasetSlug/plugins/$id", params, replace: true }); },
});
